import React, { useMemo } from "react";
import CustomTag from "./CustomTag";
import { CheckCircleFilled, CheckCircleOutlined, CloseCircleFilled, CloseCircleOutlined } from "@ant-design/icons";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import AlertTypeId from "src/consts/AlertTypeId";
import EventType from "src/consts/EventType";

interface OverCurrentLimitTagProps {
  binDto: PremierPlusBinDTO | null | undefined;
}

const OverCurrentLimitTag: React.FC<OverCurrentLimitTagProps> = ({ binDto }) => {
    const overCurrentTripped = useMemo(() => {
        return binDto?.activeAlerts?.some(
          a => a.eventType === EventType.FanOverCurrent 
          || a.eventType === EventType.MachineOverCurrent1 
          || a.eventType === EventType.MachineOverCurrent2 
          || a.eventType === EventType.AugerOverCurrent
        ) ?? false;
    }, [binDto]);

  return (
    <CustomTag
    label={overCurrentTripped ? "Over-current limit NOT OK" : "Over-current limit OK"}
    icon={overCurrentTripped ? <CloseCircleFilled /> : <CheckCircleFilled />} 
    color={overCurrentTripped ? "red" : "green"}
    />
  );
};

export default OverCurrentLimitTag;
